// extracted by mini-css-extract-plugin
module.exports = {"container":"Success_container__YY__P","newsSlider":"Success_newsSlider__n3FJR"};